import React from 'react'
import './WeddingParty.css';
import colleen from '../images/COLLEEN.webp'; // with import
import emma from '../images/EMMA.webp';
import brooklynn from '../images/BROOKLYNN.webp';
import becky from '../images/BECKY.webp';
import kellen from '../images/KELLEN.webp';
import lauren from '../images/LAUREN.webp';
import katie from '../images/KATIE.webp';
import lindsay from '../images/LINDSAY.webp';
import adrian from '../images/ADRIAN.webp'; 
// import chris from '../images/CHRIS.webp';
import cody from '../images/CODY.webp'; 
import chris from '../images/CHRIS.webp'; 
import juan from '../images/JUAN.webp';
import akshar from '../images/AKSHAR.webp'; 
import eric from '../images/ERIC.webp';
import hunter from '../images/HUNTER.webp';
import robby from '../images/ROBBY.webp';
function WeddingParty() {
    return (
    <div className="wedding-party">
        <h1>Meet the Wedding Party</h1>

        <div className="bridesmaids">
            <h2>Bridesmaids</h2>
            <div className="bridesmaid-list">
                <div className="bridesmaid"><img src={emma} alt="emma"/><h3>Emma Limburg</h3></div>
                <div className="bridesmaid"><img src={brooklynn} alt="brooklynn" /><h3>Brooklynn Joyner</h3></div>
                <div className="bridesmaid"><img src={kellen} alt="kellen" /><h3>Kellen Peter</h3></div>
                <div className="bridesmaid"><img src={becky} alt="becky" /><h3>Rebecca McKenna</h3></div>
                <div className="bridesmaid"><img src={colleen} alt="colleen" /><h3>Colleen McKenna</h3></div>
                <div className="bridesmaid"><img src={katie} alt="katie" /><h3>Katie McKenna</h3></div>
                <div className="bridesmaid"><img src={lauren} alt="lauren" /><h3>Lauren Dermody</h3></div>
                <div className="bridesmaid"><img src={lindsay} alt="lindsay" /><h3>Lindsay Soo</h3></div>
            </div>
        </div>

        <div className="groomsmen">
            <h2>Groomsmen</h2>
            <div className="groomsman-list">
                <div className="groomsman"><img src={juan} alt="juan" /><h3>Juan Chavez</h3></div>
                <div className="groomsman"><img src={eric} alt="eric" /><h3>Eric Skidmore</h3></div>
                <div className="groomsman"><img src={robby} alt="robby" /><h3>Robby Dermody</h3></div>
                <div className="groomsman"><img src={chris} alt="chris" /><h3>Chris Skidmore</h3></div>
                <div className="groomsman"><img src={cody} alt="cody" /><h3>Cody Richard</h3></div>
                <div className="groomsman"><img src={akshar} alt="akshar" /><h3>Akshar Patel</h3></div>
                <div className="groomsman"><img src={hunter} alt="hunter" /><h3>Hunter Holbrook</h3></div>
                <div className="groomsman"><img src={adrian} alt="adrian"/><h3>Adrian Naylor</h3></div>
            </div>
        </div>
    </div>
    );
}

export default WeddingParty;
